export default "__VITE_ASSET__zyRSfYkL__"